import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import * as Highcharts from 'highcharts';
import { SemCallsV5Component } from '../sem-calls-v5/sem-calls-v5.component';

@Component({
	selector: 'app-sem-calls-v2',
	templateUrl: './sem-calls-v2.component.html',
	styleUrls: ['./sem-calls-v2.component.css']
})
export class SemCallsV2Component extends SemCallsV5Component implements OnInit {
	public downloadIcon: string = '../../../../../assets/images/Download_Icon_R7.svg';
	public isR103: boolean = false;
	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel
	) {
		super(analyticsService, colorUtilityService, analyticsDataModel);
	}

	ngOnInit(): void {
		super.ngOnInit();
		this.downloadIcon = this.analyticsDataModel.config.downloadIcon
			? this.analyticsDataModel.config.downloadIcon
			: this.downloadIcon;
		this.isR103 =
			this.analyticsDataModel.config.directoryName == 'default-r103' ||
			this.analyticsDataModel.config.directoryName == 'entravision-r103';
	}

	filterChange(value: any) {
		this.selectedValue = value;
		super.filterChange(value);
	}

	protected getSeriesData(graphData: any, minCallDurationFilter: any, maxCallDurationFilter: any) {
		//creating graph data with tooltip for both series
		let answeredSeriesData = [];
		let missedSeriesData = [];
		for (let i = 0; i < graphData.length; i++) {
			// answered calls
			if (graphData[i].answeredCalls > 0) {
				let time = graphData[i].time.split(':');
				time = (Number(time[0]) * 3600 + Number(time[1]) * 60 + Number(time[2])) * 1000;
				let callDurationsTooltip = graphData[i].callDurations.split(',').filter((value: any) => {
					return (
						(minCallDurationFilter == false || value > minCallDurationFilter) &&
						(maxCallDurationFilter == false || value <= maxCallDurationFilter)
					);
				});
				if (callDurationsTooltip.length > 0) {
					let plural = callDurationsTooltip.length > 1 ? 's' : '';
					callDurationsTooltip = callDurationsTooltip
						.map((duration: any, index: number) => {
							return this.isR103
								? '<b>' + (index + 1) + ' Call Answered ' + '</b><br/>'
								: '<b>Call ' + (index + 1) + ' - ' + Highcharts.dateFormat('%H:%M:%S', duration * 1000) + '</b><br/>';
						}, plural)
						.join('');
					answeredSeriesData.push([graphData[i].dateObj * 1000, time, callDurationsTooltip]);
				}
			}
			// missed Calls
			if (graphData[i].missedCalls > 0) {
				if (this.isR103) {
					let time = graphData[i].time.split(':');
					time = (Number(time[0]) * 3600 + Number(time[1]) * 60 + Number(time[2])) * 1000;
					let plural = graphData[i].missedCalls > 1 ? 's' : '';
					const tooltip = '<b>' + graphData[i].missedCalls + ' Call' + plural + ' Missed<b>';
					missedSeriesData.push([graphData[i].dateObj * 1000, time, tooltip]);
				} else {
					let time = graphData[i].time.split(':');
					time = (Number(time[0]) * 3600 + Number(time[1]) * 60 + Number(time[2])) * 1000;
					let plural = graphData[i].missedCalls > 1 ? 's' : '';
					const tooltip = '<b>' + graphData[i].missedCalls + ' Missed Call' + plural + '<b>';
					missedSeriesData.push([graphData[i].dateObj * 1000, time, tooltip]);
				}
			}
		}

		return { answeredCalls: answeredSeriesData, missedCalls: missedSeriesData };
	}

	//function to get tooltipconfig
	getToolTipConfig() {
		let customTooltip = this.chartConfig.graphConfig.customTooltip ? this.chartConfig.graphConfig.customTooltip : false;
		return {
			useHTML: true,
			borderWidth: customTooltip && customTooltip.borderWidth ? customTooltip.borderWidth : 0,
			borderRadius: customTooltip && customTooltip.borderRadius ? customTooltip.borderRadius : 5,
			backgroundColor: customTooltip && customTooltip.backgroundColor ? customTooltip.backgroundColor : '#fff',
			style: {
				textAlign:
					customTooltip && customTooltip.style && customTooltip.style.textAlign
						? customTooltip.style.textAlign
						: 'center'
			},
			formatter: function () {
				return (
					Highcharts.dateFormat('%m/%d/%Y', this.x) +
					' - ' +
					Highcharts.dateFormat('%l:%M:%S %p', this.y) +
					'<br/>' +
					this.point.tooltip
				);
			}
		};
	}
}
